import React, { useState, useEffect, useMemo, useCallback } from 'react';
import classnames from 'classnames';
import { useDispatch, useIntl, useSelector } from 'umi';
import { Layout, ConfigProvider } from 'tea-component';
// import LeftMenu from '@intelligence/layouts/NewIconMenu';
import LeftMenu from '@home/components/LeftMenu';
import { fetchMenus } from '@user-center/services/common';
import { LANGUAGE_CN, LANGUAGE_EN } from '@home/_config/config';
import { TIPS_VIEW_MODEL_NAMESPACE } from '@user-center/models/tipsView';
import { TIPS_VIEW_STATE_KEY_MAP, TIPS_VIEW_STATE_KEYS } from '@user-center/_config/tipsViewState';
import useUserCenterEvents from '@home/hooks/useUserCenterEvents';

import './index.scss';
import { YEAR_REPORT_NEW_TAG_END_DATE } from '@user-center/_config/yearReport';

interface IUserCenterLayoutProps extends IBaseProps {}

const TEA_LOCALE_MAP: Record<string, 'en' | 'zh'> = {
  [LANGUAGE_CN]: 'zh',
  [LANGUAGE_EN]: 'en',
};

const getTeaLocale = (dbLocale?: string) => {
  if (!dbLocale) return TEA_LOCALE_MAP[LANGUAGE_EN];
  return TEA_LOCALE_MAP[dbLocale] || TEA_LOCALE_MAP[LANGUAGE_EN];
};

const UserCenterLayout: React.FC<IUserCenterLayoutProps> = (props) => {
  const { style, className, children } = props;

  const dispatch = useDispatch();

  const { locale } = useIntl();

  const [menus, setMenus] = useState<IMenuItem[]>([]);

  const updateMenus = async () => {
    const res = await fetchMenus();
    setMenus(res?.data || []);
  };

  const tipsViewState = useSelector((state: any) => state?.[TIPS_VIEW_MODEL_NAMESPACE]?.data || {});

  const { activeEvents, triggerEvent } = useUserCenterEvents();

  const handleClickMenu = useCallback(
    (menu: IMenuItem) => {
      if (menu.id !== '9998') {
        return;
      }

      const menuNewEvent = activeEvents.find(event => event.tag === 'user_center_quarter_report_pc_new');
      if (menuNewEvent?.id) {
        void triggerEvent(menuNewEvent.id);
      }
    },
    [activeEvents, triggerEvent],
  );

  const processedMenus = useMemo(() => {
    const hasViewedYearReport = tipsViewState[TIPS_VIEW_STATE_KEY_MAP.YEAR_REPORT_PAGE] || false;
    const showUserDataCenterMenuNew = activeEvents.some(event => event.tag === 'user_center_quarter_report_pc_new');

    return menus.map(menu => {
      if (menu.id === '9997' && menu.path === 'year-report') {
        return {
          ...menu,
          showNew: !hasViewedYearReport && Date.now() < new Date(YEAR_REPORT_NEW_TAG_END_DATE).getTime(),
        };
      }
      if (menu.id === '9998' && menu.path === 'user-data-center/quarter-report') {
        return {
          ...menu,
          showNew: showUserDataCenterMenuNew,
        };
      }
      return menu;
    });
  }, [menus, tipsViewState, activeEvents]);

  useEffect(() => {
    updateMenus();

    dispatch({ type: `${TIPS_VIEW_MODEL_NAMESPACE}/getTipsViewState`, payload: TIPS_VIEW_STATE_KEYS });
  }, []);

  return (
    <ConfigProvider locale={getTeaLocale(locale)}>
      <Layout style={style} className={classnames('dbu-layout user-center-layout', className)}>
        <Layout.Body className="dbu-layout__body">
          <LeftMenu
            title="DataBrain User Center"
            titleCN="DataBrain用户中心"
            menuList={processedMenus as any}
            clickMenu={handleClickMenu}
          />
          <Layout.Content className="dbu-layout__content">{children}</Layout.Content>
        </Layout.Body>
      </Layout>
    </ConfigProvider>
  );
};

export default UserCenterLayout;
